import type { MonospaceInvite } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const INVITE_DATETIME_FIELDS = ['expiresAt', 'createdAt'] as const;

export const Invite = withItemType<MonospaceInvite>().defineCollection({
	name: 'MonospaceInvite',
	scopeId: MONOSPACE_SCOPE_ID,
	fields: defineSystemDateTimeFields(INVITE_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'email',
			'workspaceId',
			'workspaceRoles',
			'orgRoleId',
			'invitedById',
			'expiresAt',
			'createdAt',
		],
		endpoint: 'system/invites',
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(INVITE_DATETIME_FIELDS),
	},
});
